import styled from 'styled-components';

const Wrapper = styled.div`
    position: absolute;
    background: #FFFFFF;
    top: 68px;
    width:100%;
    min-width: 200px;
    min-height: 50px;
    // height:25vh;
    max-height: 400px;
    overflow: auto;
    // left: 6px;
    z-index: 88;
    border: #d5d5d5 solid 1px;
    border-radius: 10px;
    flex-direction: column;
    flex: 1;
    display: flex;
   
}
`;

export default Wrapper;